import { requestWithFallback } from '../httpClient';

export async function login(credentials) {
    if (
        !credentials
        || typeof credentials !== 'object'
        || Array.isArray(credentials)
        || typeof credentials.email !== 'string'
        || typeof credentials.password !== 'string'
        || typeof credentials.remember !== 'boolean'
    ) {
        throw new TypeError('Payload de autenticación inválido.');
    }

    const result = await requestWithFallback({
        moduleName: 'auth',
        endpoint: 'login',
        endpointIsKey: true,
        method: 'post',
        data: credentials,
    });

    return result.data;
}

export async function refresh(token) {
    const result = await requestWithFallback({
        moduleName: 'auth',
        endpoint: 'refresh',
        endpointIsKey: true,
        method: 'post',
        token,
    });

    return result.data;
}

export async function me(token) {
    const result = await requestWithFallback({
        moduleName: 'auth',
        endpoint: 'me',
        endpointIsKey: true,
        method: 'get',
        token,
        invalidateSessionOnUnauthorized: true,
    });

    return result.data;
}

export async function logout(token) {
    const result = await requestWithFallback({
        moduleName: 'auth',
        endpoint: 'logout',
        endpointIsKey: true,
        method: 'post',
        token,
    });

    return result.data;
}

export async function menu(token) {
    const result = await requestWithFallback({
        moduleName: 'auth',
        endpoint: 'menu',
        endpointIsKey: true,
        method: 'get',
        token,
        invalidateSessionOnUnauthorized: true,
    });

    return result.data;
}
